import { getInstance } from '../../../scripts/lib/views';
import * as Sentry from '@sentry/browser';

export default class Newsletter {

  constructor ($el) {

    this.$el = $el;
    this.valid = false;

    // source image component the overlay should be transitioned from
    this.$form = $el.querySelector('.module-newsletter__form');
    this.$input = $el.querySelector('.module-newsletter__input');
    this.$inputIcon = $el.querySelector('.module-newsletter__input-icon');
    this.$inputIconSvg = $el.querySelector('.module-newsletter__input-icon svg');
    this.$overlaySentSuccess = $el.querySelector('.module-newsletter__overlay-sent-success');
    this.$overlaySentFailure = $el.querySelector('.module-newsletter__overlay-sent-failure');
    this.closeOverlays = [...$el.querySelectorAll('.overlay__close')];

    // bind click event
    this.$form.addEventListener('submit', this.onSend.bind(this));
    this.$inputIconSvg.addEventListener('click', this.onIconClick.bind(this));
    this.$input.addEventListener('keyup', this.validate.bind(this));

    this.closeOverlays.forEach((item) => {
      item.addEventListener('click', this.onOverlayClose.bind(this));
    });

    this.processAnchorLink();
  }

  onIconClick (evt) {
    if (this.validate()) {
      this.sendForm();
    }
  }

  onOverlayClose (evt) {
    this.resetForm();
  }

  onSend (evt) {
    evt.preventDefault();
    if (this.validate()) {
      this.sendForm();
    }
  }

  resetForm () {
    this.$input.value = '';
    this.$input.removeAttribute('disabled');
    this.$inputIcon.classList.remove('input__email-icon--send');
    this.valid = true;
    this.$el.classList.remove('module-newsletter--invalid');
  }

  sendForm () {
    this.$input.setAttribute('disabled', 'disabled');
    this.$inputIcon.classList.add('input__email-icon--send');

    const that = this;

    // Build request headers for the fetch request
    const requestHeaders = new Headers();
    requestHeaders.append('Content-Type', 'application/json');

    // Build the URl using the input data
    let url = this.$el.getAttribute('data-url');
    url += '?action=newsletter_registration_request';
    url += '&pid=' + this.$el.getAttribute('data-pid');
    url += '&mindex=' + this.$el.getAttribute('data-mindex');
    url += '&email=' + this.$input.value;

    // Build the final request with the data
    const subscribeRequest = new Request(url);
    const requestData = {
      method: 'POST',
      headers: requestHeaders,
      credentials: 'same-origin'
    };

    // Run the request
    fetch(subscribeRequest, requestData)
      .then(response => {
        if (!response.ok) {
          this.logIssueToSentry(response, requestData);

          return false;
        }

        return response.json();
      })
      .then(data => {

        // Set the overlay based on the response
        if (data && data.success === true) {
          this.displayOverlay(that.$overlaySentSuccess);

          const manager = window.klaro.getManager();

          // check if manager has consent for GA and Google Analytics is loaded
          if (manager.getConsent('google-analytics') && typeof ga !== 'undefined') {
            ga('send', 'event', 'Formular', 'Newsletter', that.$el.getAttribute('data-lid'));
          }

        } else {
          this.displayOverlay(that.$overlaySentFailure);
        }

      })
      .catch(response => {
        this.displayOverlay(that.$overlaySentFailure);
        this.logIssueToSentry(response, requestData);
      });
  }

  validate () {
    if (this.$input.value.length > 0) {
      this.valid = true;
      this.$el.classList.remove('module-newsletter--invalid');
    } else {
      this.valid = false;
      this.$el.classList.add('module-newsletter--invalid');
    }

    return this.valid;
  }

  processAnchorLink () {
    const anchor = window.location.hash.substr(1);

    if (anchor === 'st-newsletter') {
      window.location.hash = '';
      this.scrollToNewsletter();
    }
  }

  scrollToNewsletter () {
    let nav = document.documentElement.querySelector('.navigation__foreground');
    let scrollTo = this.$el.offsetTop - nav.clientHeight;

    window.scrollTo({
      top: scrollTo,
      behavior: 'smooth'
    });
  }

  displayOverlay (overlay) {
    window.setTimeout(() => {
      // Display the overlay after a short timeout
      overlay.classList.add('overlay--visible');
    }, 500);
  }

  logIssueToSentry (error, requestData) {
    Sentry.withScope(scope => {
      // Set the module name as the fingerprint
      scope.setFingerprint([name]);
      // Append the fetch error to the error data
      scope.setExtra('response', error);
      scope.setExtra('data', requestData);
      // Send the error to Sentry
      Sentry.captureException('Error while submitting newsletter form');
    });
  }
}
